// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yTIi","colBig":"styles_colBig__Si5yM","colSmall":"styles_colSmall__21Qek","shopifyNameWrapper":"styles_shopifyNameWrapper__1cj4U"};